import { useQueryParams } from '@/shared/hooks';
import { CategoryConfig } from '@/shared/types/category';
import { PackagingTab, SourcingHomeTab } from '@/shared/types/sourcing-marketplace';
import { LogisticsFeeRate } from '@/shared/types/store';
import { ParamKey } from '@/shared/types/url-params';
import React, { useEffect, useState } from 'react';
import CategoryStartingPoints from '../CategoryStartingPoints';
import SourcingTabSelector from '../SourcingTabSelector';
import './index.less';

interface IProps {
  categoryConfig: { [key: string]: CategoryConfig[] };
  logisticsFeeRateLadder: LogisticsFeeRate[];
}

const SourcingHomepage = ({ categoryConfig, logisticsFeeRateLadder }: IProps) => {
  const [selectedTab, setSelectedTab] = useState<SourcingHomeTab>(SourcingHomeTab.ALL);

  const { queryParams, setQueryParams } = useQueryParams<{}>();

  useEffect(() => {
    const tab = queryParams.get(ParamKey.HOMEPAGE_CATEGORY);
    if (tab) {
      setSelectedTab(tab as SourcingHomeTab);
    }
  }, [queryParams]);

  const getTabsToShow = (): SourcingHomeTab[] => {
    if (selectedTab === SourcingHomeTab.ALL) {
      return [
        SourcingHomeTab.PRODUCTS,
        SourcingHomeTab.PACKAGING,
        SourcingHomeTab.BUSINESS_AND_CREATIVE_SERVICES,
        SourcingHomeTab.WEBSITE_DEVELOPMENT,
      ];
    } else {
      return [selectedTab];
    }
  };

  const toggleTab = (tab: SourcingHomeTab) => {
    setSelectedTab(tab);
    setQueryParams({
      [ParamKey.HOMEPAGE_CATEGORY]: tab,
      [ParamKey.PACKAGING_TAB]: tab === SourcingHomeTab.PACKAGING ? PackagingTab.GET_IN_8_10_DAYS : null,
    });
  };

  return (
    <div className="sourcing-home">
      <SourcingTabSelector selectedTab={selectedTab} toggleTab={toggleTab} />
      {getTabsToShow().map((tab: SourcingHomeTab) => (
        <CategoryStartingPoints
          key={tab}
          tabType={tab as SourcingHomeTab}
          selectedTab={selectedTab}
          categoryConfig={categoryConfig}
          logisticsFeeRateLadder={logisticsFeeRateLadder}
        />
      ))}
    </div>
  );
};

export default SourcingHomepage;
